module.exports = "img/spinner.0b29ec9.gif";